module.exports = __webpack_public_path__ + "static/img/PWA.5e727a6a.png";